import { SEELAY_URL } from "../../content/seelayBrand";

export function SeelayBuiltByAnswer() {
  return (
    <p className="px-5 sm:px-6 pb-5 text-sm text-muted-foreground">
      PageTest is built by{" "}
      <a
        href={SEELAY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-foreground underline underline-offset-2 hover:text-foreground/80 transition-colors"
      >
        Seelay
      </a>{" "}
      (Full stack development studio)
    </p>
  );
}
